export enum SessionGraphQLActionType {
  refreshAuthToken = 'refreshAuthToken'
}
